import { render, staticRenderFns } from "./NewnessTable.vue?vue&type=template&id=052004da&"
import script from "./NewnessTable.vue?vue&type=script&lang=js&"
export * from "./NewnessTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports